import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './MatchDetails.css';

function MatchDetails() {
  const [selectedOption, setSelectedOption] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const match = location.state?.match;

  const amountOptions = [25, 50, 100, 200, 500, 1000, 2000, 5000];

  const handleEnterClick = (option) => {
    setSelectedOption(option);
    setShowPopup(true);
  };

  const handleAmountSelect = (amount) => {
    setSelectedAmount(amount);
  };

  const handleCustomAmountChange = (e) => {
    setSelectedAmount(e.target.value);
  };

  const handlePlaceBet = () => {
    if (selectedOption === 'parlay') {
      navigate('/parlay', {
        state: {
          match,
          amount: selectedAmount,
          type:selectedOption
        }
      });
    } else if (selectedOption === '4ka100') {
      navigate('/wheel', {
        state: {
          match,
          amount: selectedAmount
        }
      });
    }
  };

  if (!match) {
    return (
      <div className="match-details-page">
        <div className="match-details-header">
          <button className="back-button" onClick={() => navigate(-1)}>
            <span>←</span> Back
          </button>
          <h1 className="tournament-title">Match not found</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="match-details-page">
      <div className="match-details-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <span>←</span>
        </button>
        <h1 className="tournament-title">{match.tournament}</h1>
      </div>

      <div className="match-details-card">
        <div className="teams-container">
          <div className="team-detail">
            <h2 className="team-name">{match.team1}</h2>
          </div>
          <div className="match-info-large">
            <div className="vs-text">VS</div>
            <div className="match-time">{match.matchTime}</div>
          </div>
          <div className="team-detail">
            <h2 className="team-name">{match.team2}</h2>
          </div>
        </div>
        
        <div className="match-date-display">
          {match.matchDate}
        </div>

        <div className="betting-options">
          <h3 className="betting-title">Select Betting Option</h3>
          
          <div className="bet-options-grid">
            <div 
              className={`bet-option ${selectedOption === '4ka100' ? 'selected' : ''}`}
              onClick={() => handleEnterClick('4ka100')}
            >
              <div className="bet-option-header">
                <h4>4 ka 100</h4>
                <span className="multiplier">25x</span>
              </div>
              <p className="bet-description">
                Stake ₹4 to win ₹100. Higher risk, higher reward!
              </p>
              <button className="enter-bet-button">Enter</button>
            </div>

            <div 
              className={`bet-option ${selectedOption === 'parlay' ? 'selected' : ''}`}
              onClick={() => handleEnterClick('parlay')}
            >
              <div className="bet-option-header">
                <h4>Parlay Role</h4>
                <span className="multiplier">Various</span>
              </div>
              <p className="bet-description">
                Combine multiple bets for bigger potential winnings!
              </p>
              <button className="enter-bet-button">Enter</button>
            </div>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="bet-popup-overlay">
          <div className="bet-popup">
            <h3 className="popup-title">Select Your Stake</h3>
            <p className="popup-subtitle">Select Coin</p>
            
            <div className="amount-options">
              {amountOptions.map((amount) => (
                <button
                  key={amount}
                  className={`amount-button ${selectedAmount === amount ? 'selected' : ''}`}
                  onClick={() => handleAmountSelect(amount)}
                >
                  🪙{amount}
                </button>
              ))}
            </div>

            <div className="custom-amount">
              <input
                type="number"
                placeholder="Enter custom amount"
                value={selectedAmount}
                onChange={handleCustomAmountChange}
                min="25"
                max="5000"
                className="custom-amount-input"
              />
            </div>

            <div className="popup-buttons">
              <button className="cancel-button" onClick={() => setShowPopup(false)}>
                Cancel
              </button>
              <button 
                className="place-bet-button"
                onClick={handlePlaceBet}
                disabled={!selectedAmount}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MatchDetails; 
